export default "__VITE_ASSET__D1ZAD196__"